import { Button, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Grid, LinearProgress, Paper, Slide, Switch, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from "@mui/material";
import { blue } from "@mui/material/colors";
import { forwardRef, useState } from "react";
import { validPercentage, validPrice, validPriceNeg } from "../booking/booking_halper";
import { adjustFuelFieldEdit, adjustGstFieldEdit, adjustSubTotalFieldEdit, adjustTotalFieldEdit, calcAmountFieldEdit } from "./price_edit_halper_day";
import { deskDataUpdate } from "./edit_halper";
import { dateUsaToTimestamp, textDateToChrome } from "../frames/common";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function PriceEditDay({ data, open, handleClose, onSuccess }) {
    const [inputErrors, setInputErrors] = useState({});
    const [billBreakout, setBillBreakout] = useState(null);
    const [isFuel, setIsFuel] = useState(false);
    const [isGst, setIsGst] = useState(false);
    const [taxChange, setTaxChange] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSelfClose = () => {
        if (isLoading) return;
        setInputErrors({});
        setBillBreakout(null);
        setIsFuel(false);
        setIsGst(false);
        setTaxChange(false);
        setIsLoading(false);
        handleClose();
    }

    const handleSelfSubmit = (event) => {
        event.preventDefault();
        const frm_data = new FormData(event.currentTarget);
        const amount = frm_data.get("amount");
        const other = frm_data.get("other");
        const fuel = frm_data.get("fuel");
        const gst = frm_data.get("gst");
        var flag = true;
        if (__error_handler(validPrice(amount), "amount", "Please fill a valid amount.")) {
            flag = false;
        }
        if (__error_handler(validPriceNeg(other), "other", "Please fill a valid price.")) {
            flag = false;
        }
        if (__error_handler(validPrice(fuel), "fuel", "Please fill a fuel charge.")) {
            flag = false;
        }
        if (__error_handler(validPrice(gst), "gst", "Please fill a valid price.")) {
            flag = false;
        }
        setIsLoading(true);
        if (flag) {
            const _json = {
                "cn": data.cn_no, "time": dateUsaToTimestamp(textDateToChrome(data.created)),
                "destination": data.destination, "address": data.address,
                "country": data.country, "pincode": data.pincode, "weight": data.weight, "type": data.doc_type,
                "method": data.method, "amount": billBreakout.amount, "fuel": billBreakout.fuel,
                "pickup": billBreakout.pickup, "packaging": billBreakout.packaging,
                "insurance": billBreakout.insurance, "other": billBreakout.other, "gst": billBreakout.gst,
            }
            deskDataUpdate(_json).then((_) => {
                if (onSuccess) onSuccess({ "task": "price", ..._json });
                handleSelfClose();
            }).catch((err) => {
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
    }

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleAmountChange = (event) => {
        const amt = event.target.value;
        __error_handler(validPrice(amt), "amount", "Please fill a valid amount.");
        if (validPrice(amt)) setBillBreakout(calcAmountFieldEdit());
    }

    const handleOtherChange = (event) => {
        const price = event.target.value;
        __error_handler(validPriceNeg(price), "other", "Please fill a valid price.");
        if (validPriceNeg(price)) setBillBreakout(calcAmountFieldEdit());
    }

    const handleFuelChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "fuel", "Please fill a fuel charge.");
        if (validPrice(price)) setBillBreakout(adjustFuelFieldEdit());
    }

    const handleGSTChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "gst", "Please fill a valid price.");
        if (validPrice(price)) setBillBreakout(adjustGstFieldEdit());
    }

    const handleSubTotalChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "subtotal", "Please fill a valid price.");
        if (validPrice(price)) setBillBreakout(adjustSubTotalFieldEdit());
    }

    const handleTotalChange = (event) => {
        const price = event.target.value;
        __error_handler(validPrice(price), "total", "Please fill a valid price.");
        if (validPrice(price)) setBillBreakout(adjustTotalFieldEdit());
    }

    const handleFuelrateChange = (event) => {
        const per = event.target.value;
        __error_handler(validPercentage(per), "fuel_rate", "Please enter fuel rate maximum 35%.");
        if (validPercentage(per)) setBillBreakout(calcAmountFieldEdit());
    }

    const handleGstRateChange = (event) => {
        const per = event.target.value;
        __error_handler(validPercentage(per), "gst_rate", "Please enter GST rate maximum 28%.");
        if (validPercentage(per)) setBillBreakout(calcAmountFieldEdit());
    }

    const handleIsGstChange = (event) => {
        setIsGst(event.target.checked);
        setBillBreakout(calcAmountFieldEdit());
    }

    const handleIsFuelChange = (event) => {
        setIsFuel(event.target.checked);
        setBillBreakout(calcAmountFieldEdit());
    }

    if (data === null || !open) return (<></>);

    if (billBreakout === null) {
        const subtotal = data.amount + data.other + data.pickup + data.packaging + data.fuel;
        const sale = subtotal + data.gst;
        const total = sale + data.insurance;
        const gst_rate = (data.gst * 100) / subtotal;
        const fuel_rate = (data.fuel * 100) / (subtotal - data.fuel);
        setBillBreakout({
            "amount": data["amount"], "other": data["other"], "pickup": data["pickup"], "packaging": data["packaging"],
            "fuel": data["fuel"], "gst": data["gst"], "insurance": data["insurance"],
            "subtotal": subtotal, "total": total, "fuel_rate": fuel_rate, "gst_rate": gst_rate
        });
        setIsFuel(Boolean(data?.amount) ? Boolean(fuel_rate) : Boolean(data?.quote_fuel_rate));
        setIsGst(Boolean(data?.amount) ? Boolean(gst_rate) : Boolean(data?.gst_num));
        return (<></>);
    }

    return (
        <Dialog open={open} onClose={handleSelfClose} TransitionComponent={Transition} keepMounted component="form" onSubmit={handleSelfSubmit}>
            <DialogTitle variant="h5" color="info">{data.cn_no}</DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Collapse in={!taxChange}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                            <Typography variant="caption">Price Correction</Typography>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="amount" defaultValue={data.amount} fullWidth autoFocus error={inputErrors.amount} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.amount} placeholder=" ₹" label="Booking Amount" onKeyUp={handleAmountChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="other" defaultValue={data.other} fullWidth error={inputErrors.other} type="number" slotProps={{ htmlInput: { step: 0.01, min: -100000, max: 100000 } }} helperText={inputErrors.other} placeholder=" ₹" label="Other Charges (Discount)" onKeyUp={handleOtherChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="pickup" defaultValue={billBreakout.pickup.toFixed(2)} fullWidth error={inputErrors.pickup} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.pickup} placeholder=" ₹" label="Pickup" onBlur={handleOtherChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="packaging" defaultValue={billBreakout.packaging.toFixed(2)} fullWidth error={inputErrors.packaging} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.packaging} placeholder=" ₹" label="Packaging" onBlur={handleOtherChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="insurance" defaultValue={billBreakout.insurance.toFixed(2)} fullWidth error={inputErrors.insurance} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.insurance} placeholder=" ₹" label="Insurance" onBlur={handleOtherChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }} sx={{ display: isGst && isFuel ? "" : "none" }}>
                            <TextField variant="outlined" name="subtotal" defaultValue={billBreakout.subtotal.toFixed(2)} fullWidth error={inputErrors.subtotal} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.subtotal} placeholder=" ₹" label="Taxable Total" onBlur={handleSubTotalChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="total" defaultValue={billBreakout.total.toFixed(2)} fullWidth error={inputErrors.total} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.total} placeholder=" ₹" label="Total" onBlur={handleTotalChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <Divider />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <TableContainer component={Paper}>
                                <Table size="small" aria-label="Price Breakout">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Consigment Booking</TableCell>
                                            <TableCell align="right">₹ {billBreakout.amount}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{data.pickup_count} pickup and {data.packaging_count} packaging charge</TableCell>
                                            <TableCell align="right">₹ {billBreakout.pickup ?? 0 + billBreakout.packaging ?? 0}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>{Math.abs(billBreakout.other) <= 10 ? "Adjustment" : billBreakout.other >= 10 ? "Other Charge" : "Discount 🎁"}</TableCell>
                                            <TableCell align="right">₹ {billBreakout.other}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Insurance (18% GST included)</TableCell>
                                            <TableCell align="right">₹ {billBreakout.insurance}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Fuel Charge</TableCell>
                                            <TableCell align="right">₹ {billBreakout.fuel}</TableCell>
                                        </TableRow>
                                        <TableRow style={{ background: blue[50] }}>
                                            <TableCell>Taxable Value</TableCell>
                                            <TableCell align="right">₹ {isGst ? billBreakout.subtotal.toFixed(2) : ((billBreakout.subtotal * 100 / 118).toFixed(2))}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>SGST + CGST</TableCell>
                                            <TableCell align="right">₹ {isGst ? billBreakout.gst.toFixed(2) : (billBreakout.subtotal - (billBreakout.subtotal * 100 / 118)).toFixed(2)}</TableCell>
                                        </TableRow>
                                        <TableRow style={{ background: blue[100] }}>
                                            <TableCell>Payable Amount</TableCell>
                                            <TableCell align="right">₹ {billBreakout.total.toFixed(2)}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Collapse>
                <Collapse in={taxChange}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                            <Typography variant="caption">Price Correction</Typography>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <FormControlLabel control={<Switch name="is_fuel" checked={isFuel} />} label="Fuel Surcharge" onChange={handleIsFuelChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <FormControlLabel control={<Switch name="is_gst" checked={isGst} />} label="GST on Price" onChange={handleIsGstChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="fuel_rate" disabled={!isFuel} defaultValue={Boolean(data?.fuel_rate) ? billBreakout.fuel_rate.toFixed(2) : data.quote_fuel_rate ?? 35} fullWidth error={inputErrors.fuel_rate} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 50 } }} helperText={inputErrors.fuel_rate} placeholder="Percentage" label="Fuel Surchate Rate" onKeyUp={handleFuelrateChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="fuel" defaultValue={data.fuel} fullWidth error={inputErrors.fuel} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.fuel} placeholder="Fuel (35%)" label="Fuel" onKeyUp={handleFuelChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="gst_rate" disabled={!isGst} defaultValue={Boolean(data?.gst_rate) ? billBreakout.gst_rate.toFixed(2) : 18} fullWidth error={inputErrors.gst_rate} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 38 } }} helperText={inputErrors.gst_rate} placeholder="Percentage" label="GST Rate" onKeyUp={handleGstRateChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="gst" defaultValue={data.gst} fullWidth error={inputErrors.gst} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.gst} placeholder=" ₹" label="GST" onKeyUp={handleGSTChange} />
                        </Grid>
                    </Grid>
                </Collapse>
            </DialogContent>
            {isLoading ? <LinearProgress color="secondary" /> : ""}
            <DialogActions sx={{ pb: 3, px: 3 }}>
                <Button variant="outlined" disabled={isLoading} onClick={handleSelfClose}>Cancel</Button>
                <Button variant="outlined" disabled={isLoading} color="error" onClick={() => { setTaxChange(!taxChange); }}>Change Tax Rate</Button>
                <Button variant="contained" disabled={isLoading} color="warning" type="submit">Save</Button>
            </DialogActions>
        </Dialog>
    );
}
export default PriceEditDay;
